import { render, staticRenderFns } from "./BaseSmallDesk.vue?vue&type=template&id=d753d5de&scoped=true"
import script from "./BaseSmallDesk.vue?vue&type=script&lang=js"
export * from "./BaseSmallDesk.vue?vue&type=script&lang=js"
import style0 from "./BaseSmallDesk.vue?vue&type=style&index=0&id=d753d5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d753d5de",
  null
  
)

export default component.exports